

export const sortContacts = (contacts) => {
  return [...contacts].sort((a, b) => {
    if (a.status === 'New' && b.status !== 'New') return -1;
    if (a.status !== 'New' && b.status === 'New') return 1;
    return new Date(b.timestamp) - new Date(a.timestamp);
  });
};